// Entry point on every page. Core behaviour runs right away; each feature
// module is fetched only when its markup is on the page.
import { initHeader } from './core/header.js';
import { initConsent } from './core/consent.js';
import { initSkipLinks } from './core/skip-links.js';
import { initMotion } from './core/motion.js';

initHeader();
initConsent();
initSkipLinks();
initMotion();

const features = [
    ['[data-carousel]', () => import('./features/carousel.js')],
    ['[data-lightbox] a[href], .wp-block-gallery a[href], .gallery a[href], .image-gallery-single a[href]', () => import('./features/lightbox.js')],
    ['[data-parallax]', () => import('./features/parallax.js')],
    ['.gig-list[data-visible]', () => import('./features/gig-list.js')],
    ['[data-mist]', () => import('./features/mist.js')],
    ['[data-masonry]', () => import('./features/masonry.js')],
    ['[data-reveal]:not([data-masonry])', () => import('./features/reveal.js')],
    ['[data-player]', () => import('./features/player.js')],
    ['[data-cinema]', () => import('./features/cinema.js')],
    ['[data-shelf]', () => import('./features/shelf.js')],
    ['[data-countdown]', () => import('./features/countdown.js')],
    ['[data-tour]', () => import('./features/tour.js')],
    ['[data-clip]', () => import('./features/clip.js')],
    ['[data-request]', () => import('./features/request.js')],
    ['[data-chronicle-nav]', () => import('./features/chronicle.js')],
];

for (const [selector, load] of features) {
    if (document.querySelector(selector)) {
        load().then((module) => module.default());
    }
}

// The hero's parallax and fade run on a CSS scroll timeline; only browsers
// without scroll-driven animations need the script fallback.
if (document.querySelector('.hero') && !CSS.supports('animation-timeline: view()')) {
    import('./features/hero-scroll.js').then((module) => module.default());
}
